import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Category } from "../../models/category";
import { CategoryService } from "../../services/category.service";
import { KeywordSearchResultsComponent } from "../../keyword/keyword-search-results/keyword-search-results.component";
import { RouterOutlet } from "@angular/router";
import { AdsenseModule } from "ng2-adsense";
import { FooterComponent } from "../footer/footer.component";

@Component({
    selector: "fw-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrls: ["./sidenav.component.scss"],
    imports: [KeywordSearchResultsComponent, RouterOutlet, AdsenseModule, FooterComponent]
})
export class SidenavComponent implements OnInit {
  @Input() open: boolean;
  @Output() openedChange = new EventEmitter<boolean>();

  public cats: Category[];

  constructor(private catSrv: CategoryService) {}

  public openedChanged(isOpen: boolean) {
    this.openedChange.emit(isOpen);
  }

  ngOnInit() {
    this.catSrv.allByProjectId(1).subscribe((cats) => {
      this.cats = cats["categories"];
    });
  }
}
